export default "__VITE_PUBLIC_ASSET__331ea225__"